import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=6116b56b&"
import script from "./ProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports